import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PainelComponent } from './painel/painel.component';
import { CalcdpvatComponent } from './calcdpvat/calcdpvat.component';

const routes: Routes = [
  { path: 'home', component: PainelComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'dpvat', component: CalcdpvatComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
